import axios from 'axios';

// In Docker, nginx proxies /api to backend, so use relative URL
// For local dev, set REACT_APP_BACKEND_URL in .env file
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Helper function to build API URLs (for components using fetch directly)
export const getApiUrl = (path) => {
  const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
  return `${baseUrl}${path}`;
};

// Services
export const getServices = async () => {
  const response = await apiClient.get('/services');
  return response.data;
};

export const getServiceHealth = async (serviceName) => {
  const response = await apiClient.get(`/services/${serviceName}/health`);
  return response.data;
};

// Metrics
export const getMetrics = async (serviceName, metricName, limit = 100) => {
  const response = await apiClient.get(`/metrics/${serviceName}/${metricName}`, {
    params: { limit },
  });
  return response.data;
};

export const generateRealtimeMetric = async (serviceName, metricName) => {
  const response = await apiClient.post(`/metrics/realtime`, null, {
    params: { service_name: serviceName, metric_name: metricName },
  });
  return response.data;
};

// Anomaly Detection functionality removed to slim down the application
// Services, Traces, and Dependencies functionality preserved

// Traces
export const getTraces = async (limit = 50, status = null) => {
  const params = { limit };
  if (status) params.status = status;
  const response = await apiClient.get('/traces', { params });
  return response.data;
};

export const generateTrace = async (injectIssue = false) => {
  const response = await apiClient.post('/traces/generate', null, {
    params: { inject_issue: injectIssue },
  });
  return response.data;
};

export const getTrace = async (traceId) => {
  const response = await apiClient.get(`/traces/${traceId}`);
  return response.data;
};

export const getTraceStats = async (traceId) => {
  const response = await apiClient.get(`/traces/${traceId}/stats`);
  return response.data;
};

export const getTraceCriticalPath = async (traceId) => {
  const response = await apiClient.get(`/traces/${traceId}/critical-path`);
  return response.data;
};

// Dashboard
export const getDashboardStats = async () => {
  const response = await apiClient.get('/dashboard/stats');
  return response.data;
};

export const getRealtimeData = async () => {
  const response = await apiClient.get('/dashboard/realtime');
  return response.data;
};

// Anomaly detection endpoint removed to slim down the application
